import React, { useContext, useEffect, useRef, useState } from 'react'
import { useSideBarContext } from '../context/SidebarContext';
import { Bell, KeyRound, LogOut, User } from 'lucide-react';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import { AuthContext } from '../context/AuthContext';
import { LogoutApi } from '../redux/actions/auth/LogoutAction';
import { useDispatch, useSelector } from 'react-redux';
import { showErrorToast } from '../helpers/SweetAlert';
import axiosInstance from '../api/AxiosInstance';
import { endpoints } from '../services/endpoints';

const Header = () => {
    const dispatch = useDispatch();
    const { toggleSidebar } = useSideBarContext();
    const { logout } = useContext(AuthContext);
    const { response, error } = useSelector((state) => state.logout);
    const { response: profileResponse, error: profileError } = useSelector((state) => state.profileData);

    const [open, setOpen] = useState(false);
    const [notificationOpen, setNotificationOpen] = useState(false);
    const [notifications, setNotifications] = useState([]);
    const profilePic = profileResponse?.data?.profilePic || '/assets/images/dummy-user.png';

    const dropdownRef = useRef(null);
    const notificationRef = useRef(null);

    const toggleDropdown = () => setOpen(prev => !prev);
    const toggleNotifications = async () => {
        setNotificationOpen(prev => !prev);
        if (notifications.length === 0) {
            try {
                const resp = await axiosInstance.get(endpoints.notifications, { params: { limit: 5 } });
                setNotifications(resp?.data?.data?.notifications || []);
            } catch (error) {
                showErrorToast(error?.response?.data?.message || 'Failed to load notifications');
            }
        }
    };


    const handleLogout = (event) => {
        event.preventDefault();
        Swal.fire({
            title: 'Are you sure?',
            text: "You want to log out!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, log out!',
            cancelButtonText: 'No, cancel',
        }).then((result) => {
            if (result.isConfirmed) {
                // Call the logout API
                // dispatch(LogoutApi(localStorage?.getItem('authToken')));
                dispatch(LogoutApi())
            }
        });
    };
    // Close when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
            if (notificationRef.current && !notificationRef.current.contains(event.target)) {
                setNotificationOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (response?.status === true) {
            logout();
            Swal.fire(
                'Logged out!',
                'You have been successfully logged out.',
                'success'
            );
        }
    }, [response, logout, dispatch]);

    useEffect(() => {
        if (error) {
            showErrorToast(error?.data)
        }
    }, [error])

    useEffect(() => {
        if (profileError) {
            showErrorToast(profileError?.data)
        }
    }, [profileError])


    return (
        <header>
            <div className="container">
                <div className="row justify-content-between align-items-center">
                    <div className="col-5 col-md-5">
                        <div className="header-flex">
                            <button className="opnBtn" type="button" onClick={toggleSidebar} ><img src="/assets/images/align-right.svg" alt="Align" /></button>
                        </div>
                    </div>
                    <div className="col-7 col-md-7">
                        <div className="header-menu">
                            <ul className="header-menu-list">
                                {/* <li className="nav-item">
                                    <div className="search-btn_blk position-relative">
                                        <button className="header-link-btn search-btn">
                                            <span className="search-icon"><i data-lucide="search" /></span>
                                        </button>
                                        <div className="header-search">
                                            <div className="search-field">
                                                <input type="search" className="form-control" placeholder="Search" />
                                                <span className="search-icon"><i className="bi bi-search" /></span>
                                            </div>
                                        </div>
                                    </div>
                                </li> */}
                                {/* <li className="nav-item">
                                    <button className="header-link-btn header-flag">
                                        <img src="/assets/images/us.png" alt="Flag" />
                                    </button>
                                </li> */}
                                {/* <li className="nav-item">
                                    <div className="theme-mode">
                                        <input type="checkbox" className="d-none" id="themeMode" />
                                        <label htmlFor="themeMode">
                                            <span className="theme-icon">
                                                <i data-lucide="moon" />
                                                <i data-lucide="sun" />
                                            </span>
                                        </label>
                                    </div>
                                </li> */}
                                {/* <li className="nav-item">
                                    <button className="header-link-btn"><i data-lucide="circle-help" /></button>
                                </li> */}
                                <li className="nav-item" ref={notificationRef}>
                                    <div className="profile-nav-wrapper position-relative">
                                        <button className="header-link-btn notification-bell" type="button" onClick={toggleNotifications} aria-label="Notifications">
                                            <Bell />
                                        </button>
                                        {notificationOpen && (
                                            <div className="profile-list-dropdown notification-dropdown profile-drop">
                                                <ul className="list-unstyled mb-0">
                                                    {notifications.length > 0 ? notifications.map((notification) => (
                                                        <li key={notification._id}>
                                                            <div className="notification-list-item">
                                                                <span className="profile-name">{notification.title || 'Notification'}</span>
                                                                <span className="profile-email">{notification.body || notification.type || ''}</span>
                                                            </div>
                                                        </li>
                                                    )) : (
                                                        <li>
                                                            <div className="notification-list-item">
                                                                <span className="profile-email">No notifications yet</span>
                                                            </div>
                                                        </li>
                                                    )}
                                                </ul>
                                            </div>
                                        )}
                                    </div>
                                </li>
                                <li className="nav-item" ref={dropdownRef}>
                                    <div className="profile-nav-wrapper position-relative">
                                        <button className="header-link-btn profile_btn" onClick={toggleDropdown}><img src={profilePic} alt="user" /></button>

                                        {open && (<div className={`profile-list-dropdown ${open ? 'profile-drop' : ''}`}>
                                            <ul className="list-unstyled mb-0">
                                                <li>
                                                    <div className="profile-list-preview">
                                                        <span className="profile-img">
                                                            <img src={profilePic} alt="Profile" />
                                                        </span>
                                                        <span className="profile-detail">
                                                            <span className="profile-name">{profileResponse?.data?.username}</span>
                                                            <span className="profile-email">{profileResponse?.data?.email}</span>
                                                        </span>
                                                    </div>
                                                </li>
                                                <li>
                                                    <Link className="profile-links-list" to="/admin-dashboard/profile" onClick={() => setOpen(false)}><span className="navicon"><User /></span>Profile Details</Link>
                                                    <Link className="profile-links-list" to="/admin-dashboard/reset-password" onClick={() => setOpen(false)}><span className="navicon"><KeyRound /></span>Reset Password</Link>
                                                </li>
                                                <li>
                                                    <Link className="profile-links-list" to='#' onClick={handleLogout}><span className="navicon"><LogOut /></span>Logout</Link>
                                                </li>
                                            </ul>
                                        </div>
                                        )}
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </header>

    )
}

export default Header
